const paginationDefault = {
  page: 1,
  limit: 10,
};

export default paginationDefault;
